module.exports = __webpack_public_path__ + "img/hero-2027-mobile.196cceba.png";